export { WavesDirective } from './waves-effect.directive';
export { WavesModule } from './waves.module';



// WEBPACK FOOTER //
// ./src/app/angular-bootstrap-md/waves/index.ts